var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgAdobeAe = function SvgAdobeAe(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "bfc1a8ff-2748-4a06-aedf-c2d9ed6dba48",
    "data-name": "Layer 1",
    viewBox: "0 0 240 234",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "b9d11a2c-6ed1-4e8a-989b-6162a1939f50",
    "data-name": "vlpa"
  }, /*#__PURE__*/React.createElement("g", {
    id: "b7ec745d-f81a-450e-8b0e-e8f7666eb008",
    "data-name": "vlpb"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ed49733c-1cea-4146-b8f3-c1abdcc81fac",
    "data-name": "vlpc"
  }, /*#__PURE__*/React.createElement("g", {
    id: "e71409a3-7108-43c6-b80e-c97ecbea8d67",
    "data-name": "vlpd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.5,0h155A42.5,42.5,0,0,1,240,42.5v149A42.5,42.5,0,0,1,197.5,234H42.5A42.5,42.5,0,0,1,0,191.5V42.5A42.5,42.5,0,0,1,42.5,0Z",
    transform: "translate(0 0)",
    style: {
      fill: "none"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "a464d4f6-8bf7-4f6f-a0cf-7a8eaf73b5c4",
    "data-name": "vlpe"
  }, /*#__PURE__*/React.createElement("g", {
    id: "e7f21105-c783-43c9-9c04-60583af6e5ca",
    "data-name": "vlpf"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M96.4,140H59.2l-7.6,23.6a1.8,1.8,0,0,1-1.9,1.4H30.9c-1.1,0-1.4-.6-1.1-1.8L62,70.9l1-3.1a34.9,34.9,0,0,0,.6-6.5,1,1,0,0,1,.8-1.1H90.3c.7,0,1.2.3,1.3.8l36.5,102c.3,1.1,0,1.6-1,1.6H106.2a1.5,1.5,0,0,1-1.6-1.1l-8.2-24ZM65,120.1H90.4c-.6-2.1-1.4-4.6-2.3-7.2s-1.8-5.6-2.7-8.6l-2.9-9.2c-1-3.1-1.9-6-2.7-8.9l-2.2-7.8h-.2A122.8,122.8,0,0,1,74,91.3c-1.5,4.8-3,9.8-4.6,14.8S66.5,115.9,65,120.1Z",
    transform: "translate(0 0)",
    style: {
      fill: "#99f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187,131H155.3a22,22,0,0,0,3.1,8.9,15.9,15.9,0,0,0,7.3,6,31.1,31.1,0,0,0,12.8,2.5,60.2,60.2,0,0,0,10.4-1.1,37.6,37.6,0,0,0,8.9-2.3c.5-.4.8-.2.8.8v15.3a5,5,0,0,1-.2,1.2,2.3,2.3,0,0,1-.7.7,42.8,42.8,0,0,1-10,3,67.6,67.6,0,0,1-14.2,1.2c-7.6,0-14-1.2-19.2-3.5a33.7,33.7,0,0,1-12.6-9.5,36.7,36.7,0,0,1-6.9-13.1,51.8,51.8,0,0,1,.4-30.5,40.8,40.8,0,0,1,7.5-13.7,36.2,36.2,0,0,1,12.1-9.5c4.7-2.3,10.3-3.1,16.7-3.1A36.1,36.1,0,0,1,187,87.4a27.5,27.5,0,0,1,10.5,8,36.6,36.6,0,0,1,6,11.4,39.3,39.3,0,0,1,1.9,12.2c0,2.4-.1,4.5-.2,6.4s-.3,3.3-.4,4.2a1.5,1.5,0,0,1-1.4,1.3l-3.3.2a47.3,47.3,0,0,1-5.8.3c-2.3,0-4.7-.4-7.3-.4Zm-31.7-14.6h26.8a4.9,4.9,0,0,0,2.3-.8v-1a11.5,11.5,0,0,0-.6-3.7,13.2,13.2,0,0,0-13-9.2,14.1,14.1,0,0,0-13.3,7.6A20.7,20.7,0,0,0,155.3,116.4Z",
    transform: "translate(0 0)",
    style: {
      fill: "#99f"
    }
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAdobeAe, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/adobe-ae.922aa904.svg";
export { ForwardRef as ReactComponent };